import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/**
 * XLSX 파일로 내보내기 (단일 시트)
 * @param {Array} rows - 내보낼 데이터 배열
 * @param {string} fileName - 파일명
 * @param {string} sheetName - 시트명
 * @param {Function} transformRow - 각 row를 변환하는 함수 (선택사항)
 */
export async function exportToXlsx(rows, fileName, sheetName, transformRow = null, headers = null) {
  if (!rows || rows.length === 0) {
    throw new Error('다운로드할 데이터가 없습니다.');
  }

  try {
    const wb = XLSX.utils.book_new();

    // transformRow가 있으면 변환, 없으면 그대로 사용
    const transformedData = transformRow
      ? rows.map(row => transformRow(row))
      : rows;

    // headers가 있으면 aoa_to_sheet(중복 헤더 지원), 없으면 json_to_sheet
    const ws = headers
      ? XLSX.utils.aoa_to_sheet([headers, ...transformedData])
      : XLSX.utils.json_to_sheet(transformedData);
    XLSX.utils.book_append_sheet(wb, ws, sheetName || 'Sheet1');
    
    // 파일 다운로드
    XLSX.writeFile(wb, fileName);
  } catch (error) {
    console.error('XLSX 내보내기 오류:', error);
    throw new Error(`XLSX 파일 생성 중 오류가 발생했습니다: ${error.message}`);
  }
}

/**
 * XLSX 파일로 내보내기 (다중 시트)
 * @param {Object} sheets - { sheetName: { data: Array, transformRow?: Function } } 형식의 객체
 * @param {string} fileName - 파일명
 */
export async function exportToXlsxMultiSheet(sheets, fileName) {
  if (!sheets || Object.keys(sheets).length === 0) {
    throw new Error('다운로드할 데이터가 없습니다.');
  }

  try {
    const wb = XLSX.utils.book_new();
    
    // 각 시트별로 데이터 추가
    for (const [sheetName, sheetConfig] of Object.entries(sheets)) {
      const { data, transformRow } = sheetConfig;
      
      // 데이터가 있을 때만 시트 생성
      if (data && data.length > 0) {
        const transformedData = transformRow 
          ? data.map(row => transformRow(row))
          : data;
        
        const ws = XLSX.utils.json_to_sheet(transformedData);
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      }
    }
    
    // 파일 다운로드
    XLSX.writeFile(wb, fileName);
  } catch (error) {
    console.error('XLSX 다중 시트 내보내기 오류:', error);
    throw new Error(`XLSX 파일 생성 중 오류가 발생했습니다: ${error.message}`);
  }
}
